// eslint-disable-next-line no-use-before-define
import React, { Component, Fragment } from 'react';
import { gql } from '@apollo/client';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { Query } from '@apollo/client/react/components';

import withHealthAssessment, { WithHealthAssessment } from '../../HealthAssessment';

import HAOtherMedicalProblems from './HAOtherMedicalProblems';

import { LoadingSpinner } from 'shared-components/components';

import { ApolloSaveStatus } from 'op-types';
import { HAOtherMedicalProblemsItem } from 'op-classes';

const HEALTH_ASSESMENT_QUERY = gql`
  query HealthAssessment($id: ID!) {
    healthAssessment(id: $id) {
      id
      patient {
        id
        fullName
        dob
      }
      otherMedProblemBool
      otherMedProblemDescription
      altMedicineBool
      altMedicineDescription
    }
  }
`;

interface HealthAssessmentQueryData {
  healthAssessment: {
    id: string;
    patient: {
      fullName: string;
      dob: string;
    };
    otherMedProblemBool: boolean;
    otherMedProblemDescription: string;
    altMedicineBool: boolean;
    altMedicineDescription: string;
  };
}

interface Props extends WithHealthAssessment, RouteComponentProps<{ patientId: string; haId: string }> {
  client: any;
  updateSaveStatus: ApolloSaveStatus;
  validateOnLoad: boolean;
}

class HAOtherMedicalProblemsApollo extends Component<Props> {
  public render(): JSX.Element {
    const {
      match: {
        params: { patientId },
      },
      validateOnLoad,
    } = this.props;
    return (
      <Fragment>
        <Query<HealthAssessmentQueryData> query={HEALTH_ASSESMENT_QUERY} variables={{ id: patientId }}>
          {({ loading, data }): JSX.Element => {
            if (loading) {
              return <LoadingSpinner relativeSpinner={true} />;
            }

            if (data && data.healthAssessment) {
              const haPatientInfo = new HAOtherMedicalProblemsItem();
              haPatientInfo.loadData(data.healthAssessment);
              return (
                <HAOtherMedicalProblems
                  patientId={patientId}
                  autosave={this.autosave}
                  haPatientInfo={haPatientInfo}
                  validateOnLoad={validateOnLoad}
                />
              );
            }
            return <div></div>;
          }}
        </Query>
      </Fragment>
    );
  }

  private autosave = (updateObject: object): Promise<void> => {
    const { mutateGraph, client, getSaveStatus, updateSaveStatus } = this.props;

    // Mutate the graph
    return mutateGraph(
      client,
      updateObject,
      () => {
        getSaveStatus(client).then((savingStatus) => {
          updateSaveStatus(savingStatus);
        });
      },
      () => {},
      () => {},
      async () => {
        const saveStatus = await getSaveStatus(client);
        updateSaveStatus(saveStatus);
      },
    );
  };
}

const routedComponent = withRouter(HAOtherMedicalProblemsApollo);
const haComponent = withHealthAssessment(routedComponent);
export default haComponent;
